export default "__VITE_ASSET__BFmhJqIF__"